import Sidebar from "./sidebar";
import Navbar from "./sidebar";

export default {
    Sidebar,
    Navbar,
};
